export default function Container({ children }) {
  return (
    <div className="md:w-11/12 w-full md:px-0 px-3 mx-auto">{children}</div>
  );
}
